export default function TipContent(tip, multiline) {
  const regexp = /<br\s*\/?>/;

  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    return tip;
  }

  // Multiline tooltip content
  return tip.split(regexp).map((d, i) => {
    return (
      <span key={i} className="multi-line">
        {d}
      </span>
    );
  });
}
